import { Link, useLoaderData, useSubmit } from 'react-router-dom';
import type { ScientificEntryDto } from '../application/dto/ScientificEntryDto';
import './AdminScientificEntryListPage.css';

export interface AdminScientificEntryListLoaderData {
  heading: string;
  basePath: string;
  entries: ScientificEntryDto[];
}

const STATUS_LABELS: Record<ScientificEntryDto['status'], string> = {
  draft: 'پیش‌نویس',
  published: 'منتشرشده'
};

export function AdminScientificEntryListPage() {
  const { heading, basePath, entries } = useLoaderData() as AdminScientificEntryListLoaderData;
  const submit = useSubmit();

  function handleDelete(id: string, title: string) {
    const confirmed = window.confirm(`«${title}» حذف شود؟ این عملیات قابل بازگشت نیست.`);
    if (confirmed) {
      submit(null, { method: 'post', action: `${basePath}/${id}/delete` });
    }
  }

  return (
    <div className="dma-admin-scientific-list">
      <div className="dma-admin-scientific-list__header">
        <h1>{heading}</h1>
        <Link to={`${basePath}/new`} className="dma-admin-scientific-list__add">
          افزودن مطلب جدید
        </Link>
      </div>

      {entries.length === 0 ? (
        <p className="dma-admin-scientific-list__empty">هنوز مطلبی ثبت نشده است.</p>
      ) : (
        <table className="dma-admin-scientific-list__table">
          <thead>
            <tr>
              <th>عنوان</th>
              <th>دسته‌بندی علمی</th>
              <th>وضعیت</th>
              <th>آخرین ویرایش</th>
              <th aria-hidden="true" />
            </tr>
          </thead>
          <tbody>
            {entries.map((entry) => (
              <tr key={entry.id}>
                <td>{entry.title}</td>
                <td>{entry.classification}</td>
                <td>
                  <span
                    className={`dma-admin-scientific-list__status dma-admin-scientific-list__status--${entry.status}`}
                  >
                    {STATUS_LABELS[entry.status]}
                  </span>
                </td>
                <td>{new Date(entry.updatedAt).toLocaleDateString('fa-IR')}</td>
                <td className="dma-admin-scientific-list__actions">
                  <Link to={`${basePath}/${entry.id}/edit`}>ویرایش</Link>
                  <button type="button" onClick={() => handleDelete(entry.id, entry.title)}>
                    حذف
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
